import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../config/api';
import { useLang } from '../context/LanguageContext';

const CompanySection = () => {
  const [companyData, setCompanyData] = useState(null);
  const { nl } = useLang();

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/homepage`);
      const data = await response.json();
      if (data.success && data.data.companySection) {
        setCompanyData(data.data.companySection);
      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };

  if (!companyData || !companyData.isActive) {
    return null;
  }

  return (
    <section id="company" className="company">
      {/**#b38844 */}
      <div className="container">
        <div className="company-slogan">
          <blockquote>
            <i className="fas fa-quote-left"></i>
            {(nl ? companyData.quote_nl : null) || companyData.quote || '"Aurelia Technology is not just about technology; it\'s about transforming possibilities into realities that drive human progress."'}
            <i className="fas fa-quote-right"></i>
          </blockquote>
          <cite>{companyData.author || '— Aurelia Technology'}</cite>
        </div>
        
        <div className="company-content">
          <div className="company-text">
            <h2>{(nl ? companyData.title_nl : null) || companyData.title || 'Built for the way you work'}</h2>
            <p>{(nl ? companyData.description_nl : null) || companyData.description || 'For more than a decade, we\'ve been helping organizations around the world transform how they manage their most important asset—their people—and their most critical processes.'}</p>
          
          </div>
          <div className="company-image">
            <img 
              src={companyData.image || 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=500&h=400&fit=crop'} 
              alt="Modern office" 
              style={{ width: '100%', borderRadius: '8px' }} 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanySection;